import React from 'react';

function PillarCard({ title, text, index }) {
  const delay = `reveal-d${(index % 4) + 1}`;

  return (
    <div className={`pillar-card reveal ${delay}`}>
      <div className="pillar-number">{String(index + 1).padStart(2, '0')}</div>
      <h4 className="pillar-title">{title}</h4>
      <p className="pillar-text">{text}</p>
    </div>
  );
}

export default PillarCard;
